import welfareService from '@/service/welfare';
import { observable, action, runInAction } from 'mobx';
import moIndex from '../../store';


// 获取人均福利分布

const moWelfare = observable({
  PerCapitaWelfareDate: <any>[],
  PerWelfareDistributionDate: <any>[],
  KeyFestivalsDate: <any>[],
  KeyFestivalsList: <any>[],
  keyHolidayTable: <any>[],
});

// 获取人均福利

const getPerWelfare = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,

  };
  const PerResult = await welfareService.GetPerCapitaWelfare(parmes);
  runInAction(() => {
    const data = [PerResult?.fw_25, PerResult?.fw_50, PerResult?.fw_75];
    moWelfare.PerCapitaWelfareDate = data;
  });
});


// 获取分布数据

const getWelfareDistribution = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetPerCapitaWelfareDistribution(parmes);
  runInAction(() => {
    const list = PerResult?.map((item: any) => {
      const res: any = {};
      res.label = item.section;
      res.rate = item.percent;
      return res;
    });
    moWelfare.PerWelfareDistributionDate = list;
  });
});

// 获取重点节日数据

const getKeyFestivals = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetWelfareKeyFestivals(parmes);
  const klist: any = [];
  const kDate: any = [];
  PerResult?.forEach((item: any) => {
    klist.push(item.festival);
    kDate.push({ data: [{ rate: item.fw_25 }, { rate: item.fw_50 }, { rate: item.fw_75 }] });
  });
  runInAction(() => {
    moWelfare.KeyFestivalsDate = kDate;
    moWelfare.KeyFestivalsList = klist;
    moWelfare.keyHolidayTable = PerResult;
  });
});

const welfareInit = action(async () => {
  await Promise.all([
    getPerWelfare(),
    getWelfareDistribution(),
    getKeyFestivals(),
  ]);
});

export default moWelfare;
export { welfareInit };
